export enum Color {
    main = "#ffffff",
    auxiliary = "#e7bd42",
    tertiary = "#e7bd42",
    light = "black",
    pageBgColor = "whitesmoke"
}
